<ion-app>
  @if (!networkStatus.isOnline()) {
    <mbm-banner id="app-offline-banner" variant="offline" messageKey="pwa.offline.message"></mbm-banner>
  }
  <ion-router-outlet></ion-router-outlet>
</ion-app>

